import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import StrategyGridItem from './StrategyGridItem';
import { StrategyListItem } from 'model/modules/strategies/strategies';

interface Props {
  items: StrategyListItem[];
}

const StrategiesGrid: FC<Props> = ({ items }) => {
  const gapBetweenCards = 20;

  return (
    <Flex flexWrap="wrap" justifyContent="space-between">
      {items.map((strategy, index) => (
        <StrategyGridItem
          key={index}
          data={strategy}
          w={`calc(50% - ${gapBetweenCards / 2}px)`}
          mb={`${gapBetweenCards}px}`}
        />
      ))}
    </Flex>
  );
};

export default StrategiesGrid;
